"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var styleOverrides = {
    paper: function(param) {
        var theme = param.theme;
        return {
            '&.OriSelectPaper': {
                border: "1px solid ".concat(theme.palette.grey[500]),
                borderRadius: theme.shape.borderRadius,
                marginTop: theme.spacing(1)
            }
        };
    }
};
var _default = exports.default = {
    styleOverrides: styleOverrides
}; //# sourceMappingURL=MuiMenu.js.map
